import script from "./SystemSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemSettings.vue?vue&type=script&setup=true&lang=js"

import "./SystemSettings.vue?vue&type=style&index=0&id=5865b8bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5865b8bc"]])

export default __exports__